import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, onBeforeUnmount, onMounted, ref } from "vue";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default /*#__PURE__*/_defineComponent({
  __name: 'Appear',
  props: {
  debug: {
    type: Boolean,
    default: false
  },
  tag: {
    type: String,
    default: 'div'
  },
  thresold: {
    type: String,
    default: '25%'
  },
  delay: {
    type: Number,
    default: 0
  },
  closest: {
    type: String,
    default: ''
  },
},
  setup(__props) {

gsap.registerPlugin(ScrollTrigger)

const props = __props

const root = ref<HTMLElement | null>(null)

let timeline: gsap.core.Timeline | null = null
const initTimeline = () => {
  destroyTimeline();

  const trigger = props.closest ? root.value.closest(props.closest) : root.value;
  if (props.debug) {
    console.log('Appear', trigger)
  }

  timeline = gsap.timeline({
    scrollTrigger: {
      trigger,
      start: `top bottom-=${props.thresold}`,
      markers: props.debug,
    }, 
    delay: props.delay as number 
  });

  timeline.fromTo(
    root.value,
    {
      opacity: 0
    },
    {
      opacity: 1,
      duration: 1,
      ease: 'power1.out'
    }
  )
}

const destroyTimeline = () => {
  timeline?.scrollTrigger?.kill()
  timeline?.kill()
}


onMounted(() => {
  initTimeline()
})

onBeforeUnmount(() => {
  destroyTimeline()
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    ref_key: "root",
    ref: root
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 512))
}
}

})